<template>
	<div>
		<div class="setImages">
			<div v-if="app_info.banner_urls&&app_info.banner_urls.length > 0">
				<div v-for="(item,index) in app_info.banner_urls" :key="index" class="banner-container">
					<img :src="item" class="banner-pre">
					<div class="banner-link"><span class="banner-link-title">绑定链接：</span><a v-if="app_info.banner_links[index]" :href="app_info.banner_links[index]">{{app_info.banner_links[index]}}</a><span v-else>无</span></div>
					<el-button type="danger" @click='deleteBanner(index)'>删除本条</el-button>
				</div>
				<el-button type="primary" @click="openAddDialog" v-if="app_info.banner_urls.length<3">添加更多</el-button>
			</div>
			<div v-else>
				暂无首页轮播图，去<el-button type="primary" @click="openAddDialog">添加</el-button>
			</div>
			<el-dialog :visible.sync="showAddDialog" title='添加图片' @close="resetDialog">
				<el-upload
					ref="uploadController"
					action="https://business.id-photo-verify.com/applet_common/upload_file_url"
					:headers="{'Content-Type': 'multipart/form-data'}"
					:multiple="false"
					:http-request="uploadImage"
					name="file"
					accept="image/*"
					:limit="1"
					:on-success="getResult"
					list-type="picture">
					<el-button size="small" type="primary">点击上传</el-button>
					<div slot="tip" class="el-upload__tip">只能上传jpg/png文件。建议尺寸：1920*308或同比例</div>
					<div slot="tip" class="el-upload__tip" v-if='tempUrl'>本图片大小为：{{tempSize}}</div>
				</el-upload>
				<div style="margin-top: 20px;">
					<span>跳转链接：</span><el-input v-model="tempHref" placeholder="输入用户点击这张图片时跳转的链接,若无可不填" style="width: 500px;"></el-input>
				</div>
				<el-button type="primary" @click='submit'>提交</el-button>
			</el-dialog>
		</div>
		<div class="setImages">
			<div v-if="app_info.logo_url">
				<div class="banner-container">
					<img :src="app_info.logo_url" class="banner-pre">
					<div class="banner-link"><span class="banner-link-title">绑定链接：</span><a v-if="app_info.logo_link" :href="app_info.logo_link">{{app_info.logo_link}}</a><span v-else>无</span></div>
					<div>
						<el-button @click='deleteLogo' type="danger">删除logo</el-button>
						<el-button @click='modifyLink'>修改链接</el-button>
					</div>
				</div>
			</div>
			<div v-else>
				暂无logo，去<el-button type="primary" @click="openLogoDialog">添加</el-button>
			</div>
			<el-dialog :visible.sync="showLogoDialog" title='Logo信息修改' @close="resetDialog">
				<el-upload
					ref="uploadController"
					action="https://business.id-photo-verify.com/applet_common/upload_file_url"
					:headers="{'Content-Type': 'multipart/form-data'}"
					:multiple="false"
					:http-request="uploadImage"
					name="file"
					accept="image/*"
					:limit="1"
					:on-success="getResult"
					list-type="picture">
					<el-button size="small" type="primary">点击上传</el-button>
					<div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
				</el-upload>
				<div style="margin-top: 20px;">
					<span>跳转链接：</span><el-input v-model="tempHref" placeholder="输入用户点击logo时跳转的链接,若无可不填" style="width: 500px;"></el-input>
				</div>
				<el-button type="primary" @click='submitForLogo'>提交</el-button>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import {
	mapState,mapActions
} from "vuex";
import {
	modifyApp,
	getUploadHost
} from "../api/index.js"	
const axios = require('axios');
export default {
	data() {
		return {
			showAddDialog:false,
			showLogoDialog:false,
			tempHref:'',
			tempUrl:'',
			tempSize:''
		}
	},
	computed:{
		...mapState([
			"app_info"
		]),

	},
	mounted() {
		console.log(this.app_info)
	},
	methods:{
		openAddDialog:function(){
			this.showAddDialog= true
		},
		openLogoDialog:function(){
			this.showLogoDialog =true;
		},
		getResult:function(res){
			console.log(res)
		},
		uploadImage:function(param){
			console.log(param)
			getUploadHost().then(res=>{
				console.log(res)
				const {key,OSSAccessKeyId,policy,signature,host}=res.data.result;
				let formData = new FormData();
				formData.append("key",key);
				formData.append("OSSAccessKeyId",OSSAccessKeyId);
				formData.append("policy",policy);
				formData.append("signature",signature);
				formData.append("file",param.file);
				axios({
					url:host,
					method: 'post',
					data:formData,
					headers:{'Content-Type': 'multipart/form-data'},
					withCredentials: false
				}).then(()=>{
					this.tempUrl=key;
					this.tempSize=parseFloat(param.file.size/1024)+"KB"
				})
			})
		},
		deleteBanner:function(index){
			this.app_info.banner_urls.splice(index,1);
			this.app_info.banner_keys.splice(index,1);
			this.app_info.banner_links.splice(index,1);
			modifyApp(this.app_info).then(res=>{
				console.log(res)
				if(res.data.code==200){
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.getAppInfoFromServer().catch(err=>{
						console.log(err)
						this.$message.error('系统错误，请联系管理员')
					})
				}
			})
		},
		deleteLogo:function(){
			this.app_info.logo_link="";
			this.app_info.logo_url="";
			modifyApp(this.app_info).then(res=>{
				console.log(res)
				if(res.data.code==200){
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.getAppInfoFromServer().catch(err=>{
						console.log(err)
						this.$message.error('系统错误，请联系管理员')
					})
				}
			})
		},
		submit:function(){
			if(this.tempUrl){
				this.app_info.banner_keys.push(this.tempUrl);
				if(this.tempHref){
					this.app_info.banner_links.push(this.tempHref);
				}else{
					this.app_info.banner_links.push("");
				}
				modifyApp(this.app_info).then(res=>{
					console.log(res)
					if(res.data.code==200){
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.showAddDialog=false;
						this.getAppInfoFromServer().catch(err=>{
							console.log(err)
							this.$message.error('系统错误，请联系管理员')
						})
					}
				})
			}else{
				this.$message.error('请上传一张图片！');
			}
		},
		submitForLogo:function(){
			if(this.tempUrl){
				this.app_info.logo_url=this.tempUrl;
				if(this.tempHref){
					this.app_info.logo_link=this.tempHref;
				}
				modifyApp(this.app_info).then(res=>{
					console.log(res)
					if(res.data.code==200){
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.showAddDialog=false;
						this.getAppInfoFromServer().catch(err=>{
							console.log(err)
							this.$message.error('系统错误，请联系管理员')
						})
					}
				})
			}else{
				this.$message.error('请上传一张图片！');
			}
		},
		modifyLink:function(){
			var newLink=prompt("请输入新的链接","");
			if (newLink){
				this.app_info.logo_link=newLink;
				modifyApp(this.app_info).then(res=>{
					console.log(res)
					if(res.data.code==200){
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.showAddDialog=false;
						this.getAppInfoFromServer().catch(err=>{
							console.log(err)
							this.$message.error('系统错误，请联系管理员')
						})
					}
				})
			}
		},
		resetDialog:function(){
			this.tempHref='';
			this.tempUrl='';
			this.$refs.uploadController.clearFiles()
		},
		...mapActions([
			"getAppInfoFromServer"
		]),
	}
}
</script>

<style scoped="scoped">
	.setImages{
		margin:30px 40px;
		box-shadow: 0px 4px 12px 0px rgba(66, 66, 66, 0.1);
		border-radius: 10px;
		padding:20px 80px;
		font-size: 16px;
		font-weight: bold;
		color: #4C4C4C;
	}
	.banner-container{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 5px;
	}
	.banner-pre{
		max-height: 100px;
	}
</style>
